import { inject, Injectable } from '@angular/core';
import { environment } from '@environments/environment';
import { fetchAuthSession } from 'aws-amplify/auth';
import { catchError, from, map, Observable, of } from 'rxjs';
import { Utilities } from '../utils/utilities';
import { CryptoCipherService } from './crypto-cipher.service';
import { Router, UrlTree } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  util = inject(Utilities);
  router = inject(Router);
  cryptoService = inject(CryptoCipherService);
  rootLevelEntity = ["/home", '/manage-institution', '/add-institution', '/subject-classification-report', '/manage-user'];

  private getSessionData() {
    return of({
      getIdToken: () => ({ decodePayload: () => (environment.authorizationData), getJwtToken: () => environment.authIdToken })
    })
  }

  removeUserData(url: string): void {
    localStorage.removeItem("userDetails");
    this.util.userDetails$.set('');

    if (["/home"].includes(url)) localStorage.removeItem("institutionDetails");
    this.util.getInstituionDetails();
  }

  getUserSession(): Observable<any> {
    return environment.authDisable ? this.getSessionData() : from(fetchAuthSession());
  }

  setUserData(email: string, url: string): Observable<boolean | UrlTree> {
    return this.util.getUserDetails(email).pipe(
      map((user: any) => {
        if (user?.UserDetail && user?.UserDetail[0]?.userId && user?.UserDetail[0]?.status === 'ACTIVE') {
          user.UserDetail.map((details: any) => {
            details['email'] = email;
            this.util.userDetails$.set(details);
            const secret = this.cryptoService.encryptSecret(JSON.stringify(details));
            localStorage.setItem("userDetails", secret);
          })
          if ((localStorage.getItem("institutionDetails") != null) && (url !== '/login')) {
            if (["/manage-clearing"].includes(url)) {
              const institutionDetails = JSON.parse(localStorage.getItem("institutionDetails") || '');
              const clearingProviderFlag = Boolean(institutionDetails?.clearingProviderFlag);

              if (!clearingProviderFlag)
                return this.router.createUrlTree([institutionDetails?.instPageUrl]);
            }
            return true;
          }
          else if (url.includes('non-edu-org')) {
            return true;
          }
          else if (!this.rootLevelEntity.includes(url)) {
            return this.router.createUrlTree(['/home']);
          }
          return true;
        }
        else {
          localStorage.setItem("userDetails", '');
          this.util.userDetails$.set('');
          return this.router.createUrlTree(['/no-access']);
        }
      }),
      catchError(() => {
        console.log("ERROR : User details error");
        localStorage.setItem("userDetails", '');
        this.util.userDetails$.set('');
        return of(false);
      })
    );
  }
}
